import { createSlice } from "@reduxjs/toolkit";
import {
  deleteGalleryCategory,
  getGalleryCategory,
  undoDeleteGalleryCategory,
} from "./PhotoGalleryCategory.api";

const galleryCategorySlice = createSlice({
  name: "galleryCategory",
  initialState: {
    galleryCategory: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGalleryCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getGalleryCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.galleryCategory = action.payload;
      state.dataLimit = action.payload.meta?.limit || 10;
      state.currentPage = action.payload.meta?.page || 1;
      state.totalPages = action.payload.meta?.totalPages || 0;
      state.totalData = action.payload.meta?.total || 0;
    });
    builder.addCase(getGalleryCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteGalleryCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteGalleryCategory.fulfilled, (state, action) => {
      const deletedId = action?.payload?.data?._id;
      if (state.galleryCategory.data) {
        state.galleryCategory.data = state.galleryCategory.data.filter(
          (galleryCategory) => {
            return galleryCategory._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.galleryCategory.data is not an array:",
          state.galleryCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteGalleryCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteGalleryCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteGalleryCategory.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.galleryCategory.data) {
        state.galleryCategory.data = state.galleryCategory.data.filter(
          (galleryCategory) => {
            return galleryCategory._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.galleryCategory.data is not an array:",
          state.galleryCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteGalleryCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = galleryCategorySlice.actions;
export default galleryCategorySlice.reducer;
